import DepartmentsPage from "./pages/DepartmentsPage";
import DepartmentDetailsPage from "./pages/DepartmentDetailsPage";

/** Gated on the privilege — see the note in chapter/routes.tsx. */
export const departmentsRoutes = [
  { path: "/departments", element: <DepartmentsPage />, perms: ["department.access"] },
  {
    path: "/departments/:id",
    element: <DepartmentDetailsPage />,
    perms: ["department.access"],
  },
];
